import axios from 'axios';
import { buildApiUrl } from '../config/api';


export const EstadoPostulanteService = {
    getEstadoPostulacion: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/ajustes/estadopostulacion'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estadoPostulacion;
        } catch (error) {
            console.error('Error en EstadoPostulanteService:', error);
            throw error;
        }
    },
};
